module.exports = __webpack_public_path__ + "static/media/anu.b5bdee20.png";